import { render, staticRenderFns } from "./EmployeeRolesTableItem.vue?vue&type=template&id=cc9ffa44&"
import script from "./EmployeeRolesTableItem.vue?vue&type=script&lang=js&"
export * from "./EmployeeRolesTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports